<template>
    <div class="container flex flex-direction">
        <dv-loading v-if="loading" class="loading">Loading...</dv-loading>
        <div class="header-container flex align-center justify-between">
            <div class="flex align-center">
                <div class="btn-container" @click="$router.go(-1)">
                    <div class="btn"><i class="iconfont icon-fanhui margin-right-xs"></i>返回</div>
                </div>
            </div>
            <div class="page-title">双暖24小时健康监测</div>
            <div class="flex align-center">
                <div class="btn-container max right margin-left-sm">
                    <div class="btn">{{ cur_time|date_time }}</div>
                </div>
            </div>
        </div>

        <div class="content-container flex flex-sub">
            <video class="bg-anim" controls360=no webkit-playsinline playsinline x5-playsinline x5-video-player-type="h5-page" src="../../../assets/img/data/bg_health_infoanim_anim_men.mp4" loop autoplay :controls="false" muted v-if="member_info.sex=== 1"></video>
            <video class="bg-anim" controls360=no webkit-playsinline playsinline x5-playsinline x5-video-player-type="h5-page" src="../../../assets/img/data/bg_health_infoanim_anim_women.mp4" loop autoplay :controls="false" muted v-else></video>
            <div class="info-container total-container max flex flex-direction">
                <div class="classify-title self-center">健康监测实时数据</div>
                <div class="flex flex-wrap justify-between">
                    <div class="total-item flex align-center">
                        <div class="label-container flex flex-direction align-center justify-center">
                            <img class="image" src="../../../assets/img/data/icon_health_info_1.png">
                            <div class="label">心率</div>
                        </div>
                        <health-xin-lv-chart class="echarts" :values="member_info.xinlv"></health-xin-lv-chart>
                    </div>
                    <div class="total-item flex align-center">
                        <div class="label-container flex flex-direction align-center justify-center">
                            <img class="image" src="../../../assets/img/data/icon_health_info_2.png">
                            <div class="label">血压</div>
                        </div>
                        <health-xue-ya-chart class="echarts" :values="member_info.xueya"></health-xue-ya-chart>
                    </div>
                    <div class="total-item flex align-center">
                        <div class="label-container flex flex-direction align-center justify-center">
                            <img class="image" src="../../../assets/img/data/icon_health_info_3.png">
                            <div class="label">血氧</div>
                        </div>
                        <health-xue-yang-chart class="echarts" :values="member_info.xueyang"></health-xue-yang-chart>
                    </div>
                    <div class="total-item flex align-center">
                        <div class="label-container flex flex-direction align-center justify-center">
                            <img class="image" src="../../../assets/img/data/icon_health_info_4.png">
                            <div class="label">体温</div>
                        </div>
                        <health-ti-wen-chart class="echarts" :values="member_info.tiwen"></health-ti-wen-chart>
                    </div>
                    <div class="total-item flex align-center">
                        <div class="label-container flex flex-direction align-center justify-center">
                            <img class="image" src="../../../assets/img/data/icon_health_info_5.png">
                            <div class="label">步数</div>
                        </div>
                        <div class="number-container flex align-center justify-center">
                            <div class="number">{{ member_info.steps }}</div>
                            <div class="label">步</div>
                        </div>
                    </div>
                    <div class="total-item flex align-center">
                        <div class="label-container flex flex-direction align-center justify-center">
                            <img class="image" src="../../../assets/img/data/icon_health_info_6.png">
                            <div class="label">卡路里</div>
                        </div>
                        <div class="number-container flex align-center justify-center">
                            <div class="number">{{ member_info.steps * 0.03 }}</div>
                            <div class="label">cal</div>
                        </div>
                    </div>
                    <div class="total-item flex align-center">
                        <div class="label-container flex flex-direction align-center justify-center">
                            <img class="image" src="../../../assets/img/data/icon_health_info_7.png">
                            <div class="label">睡眠</div>
                        </div>
                        <div class="number-container flex align-center justify-center">
                            <div class="number">{{ member_info.sleep_time_hour }}</div>
                            <div class="label">小时</div>
                            <div class="number">{{ member_info.sleep_time_minute }}</div>
                            <div class="label">分钟</div>
                        </div>
                    </div>
                    <div class="total-item flex align-center">
                        <div class="label-container flex flex-direction align-center justify-center">
                            <img class="image" src="../../../assets/img/data/icon_health_info_8.png">
                            <div class="label">定位</div>
                        </div>
                        <div class="number-container flex align-center justify-center">
                            <div class="address">{{ member_info.address }}</div>
                        </div>
                    </div>
                </div>
                <div class="yj-total-container flex flex-wrap justify-between">
                    <div class="yj-item flex" :class="{error:member_info.electricity_order_num}">
                        <i class="icon iconfont icon-renzhengdunpaianquanbaozhangzhibao"></i>
                        <div class="flex flex-direction margin-left-xs">
                            <div class="label">漏电预警</div>
                            <div class="state">{{ member_info.electricity_order_num ? '预警' : '正常' }}</div>
                        </div>
                    </div>
                    <div class="yj-item flex" :class="{error:member_info.charge_order_num}">
                        <i class="icon iconfont icon-jinggao1"></i>
                        <div class="flex flex-direction margin-left-xs">
                            <div class="label">充电过载预警</div>
                            <div class="state">{{ member_info.charge_order_num ? '预警' : '正常' }}</div>
                        </div>
                    </div>
                    <div class="yj-item min flex" :class="{error:member_info.fall_order_num}">
                        <i class="icon iconfont icon-renzhengdunpaianquanbaozhangzhibao"></i>
                        <div class="flex flex-direction margin-left-xs">
                            <div class="label">摔倒预警</div>
                            <div class="state">{{ member_info.fall_order_num ? '预警' : '正常' }}</div>
                        </div>
                    </div>
                    <div class="yj-item min flex" :class="{error:member_info.smoke_order_num}">
                        <i class="icon iconfont icon-renzhengdunpaianquanbaozhangzhibao"></i>
                        <div class="flex flex-direction margin-left-xs">
                            <div class="label">烟感预警</div>
                            <div class="state">{{ member_info.smoke_order_num ? '预警' : '正常' }}</div>
                        </div>
                    </div>
                    <div class="yj-item min flex" :class="{error:member_info.water_order_num}">
                        <i class="icon iconfont icon-renzhengdunpaianquanbaozhangzhibao"></i>
                        <div class="flex flex-direction margin-left-xs">
                            <div class="label">水感预警</div>
                            <div class="state">{{ member_info.water_order_num ? '预警' : '正常' }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="anim-container flex-sub">
<!--                <img class="image" src="../../../assets/img/data/anim_health_info_men.gif">-->
            </div>
            <div class="flex flex-direction">
                <div class="info-container member-container min flex flex-direction">
                    <div class="classify-title self-center">人员列表</div>
                    <div class="member-operate-container flex align-center">
                        <i class="operate el-icon-arrow-left" @click="changeMember(-1)"></i>
                        <div class="flex-sub flex align-center justify-center">
                            <img class="avatar" src="../../../assets/img/data/avatar_health_info.png">
                            <div class="flex flex-direction margin-left-xs">
                                <div class="name">{{ member_info.name }}</div>
                                <div class="flex align-center margin-top-xs">
                                    <div class="year"><span>{{ member_info.age }}</span>岁</div>
                                    <div class="sex margin-left-xs">
                                        <i class="icon" :class="member_info.sex=== 1 ? 'el-icon-male' : 'el-icon-female'"></i>{{member_info.sex === 1 ? '男' : '女'}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <i class="operate el-icon-arrow-right" @click="changeMember(1)"></i>
                    </div>
                    <div class="label-title margin-top-sm">基础信息</div>
                    <div class="flex align-center margin-top-xs">
                        <div class="info">联系电话：<span>{{ member_info.phone }}</span></div>
                        <div class="info margin-left-sm">
                            紧急联系人电话：<span>{{ member_info.emergency_contact_phone }}</span></div>
                    </div>
                    <div class="flex align-center margin-top-xs">
                        <div class="info">专属管家：<span>{{ member_info.guanjia_name }}</span></div>
                        <div class="info margin-left-sm">管家联系电话：<span>{{ member_info.guanjia_phone }}</span></div>
                    </div>
                    <div class="flex align-center margin-top-xs">
                        <div class="info">住址：<span>{{ member_info.address }}</span></div>
                    </div>
                    <div class="label-title margin-top-sm">历史病情</div>
                    <div class="tag-container flex margin-top-xs">
                        <div class="tag" v-for="(item,index) in member_info.illness" :key="index">
                            {{item}}
                        </div>
                    </div>
                    <div class="label-title margin-top-sm">服务次数</div>
                    <div class="flex flex-wrap justify-between">
                        <div class="service-item flex flex-direction">
                            <div class="number">3</div>
                            <div class="label">巡视探访</div>
                            <img class="image" src="../../../assets/img/data/icon_health_info_service_1.png">
                        </div>
                        <div class="service-item flex flex-direction">
                            <div class="number">5</div>
                            <div class="label">生日慰问</div>
                            <img class="image" src="../../../assets/img/data/icon_health_info_service_2.png">
                        </div>
                        <div class="service-item flex flex-direction">
                            <div class="number">11</div>
                            <div class="label">节日庆祝</div>
                            <img class="image" src="../../../assets/img/data/icon_health_info_service_3.png">
                        </div>
                        <div class="service-item flex flex-direction">
                            <div class="number">27</div>
                            <div class="label">天气提醒</div>
                            <img class="image" src="../../../assets/img/data/icon_health_info_service_4.png">
                        </div>
                        <div class="service-item flex flex-direction" v-for="(item,index) in member_info.service" :key="index">
                            <div class="number">{{ item.num }}</div>
                            <div class="label">{{ item.name }}</div>
                            <img class="image" src="../../../assets/img/data/icon_health_info_service_1.png">
                        </div>
                    </div>
                </div>

                <div class="info-container yj-container flex-sub flex flex-direction margin-top-sm">
                    <div class="classify-title self-center">预警事件</div>
                    <div class="yj-item flex align-center justify-between" v-for="(item,index) in member_info.save_order" :key="index">
                        <div class="flex align-center">
                            <div class="label">{{ index + 1 }}</div>
                            <div class="name">{{ item.service_type | service_type }}</div>
                        </div>
                        <div class="time">{{ item.add_time }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {zhDate} from "@/utils/utils";
import {dataScreenOneUser, dataScreenUserArr} from "@/api/tongji";
import HealthXinLvChart from "@/views/digitize/components/HealthXinLvChart";
import HealthXueYaChart from "@/views/digitize/components/HealthXueYaChart";
import HealthXueYangChart from "@/views/digitize/components/HealthXueYangChart";
import HealthTiWenChart from "@/views/digitize/components/HealthTiWenChart";

export default {
    name: "health_info",
    components: {HealthTiWenChart, HealthXueYangChart, HealthXueYaChart, HealthXinLvChart},
    data() {
        return {
            id:'',
            members: [],
            cur_index: -1,
            cur_time: new Date().getTime(),
            style: {
                fontSize: 26,
                fill: '#ffd200',
                fontFamily: 'PingFang SC',
                fontWeight: 'bold',
                FontStyle: 'italic'
            },
            min_style: {
                width: '120px',
                fontSize: 20,
                fill: '#ffd200',
                fontFamily: 'PingFang SC',
                fontWeight: 'bold',
                FontStyle: 'italic'
            },
            min_blue_style: {
                width: '120px',
                fontSize: 20,
                fill: '#15b3e7',
                fontFamily: 'PingFang SC',
                fontWeight: 'bold',
                FontStyle: 'italic'
            },
            loading: false,
            member_info: {
                xinlv: [],
                xueya: [],
                xueyang: [],
                tiwen: [],
                steps: 0,
                electricity_order_num: 0,
                charge_order_num: 0,
                fall_order_num: 0,
                smoke_order_num: 0,
                water_order_num: 0,
                sleep_time_hour: 0,
                sleep_time_minute: 0,
                address: '',
            },
        }
    },
    created() {
        this.id = Number(this.$route.query.id || 0)
        this.getCurrentTime()
    },
    mounted() {
        this.onload()
    },
    methods: {
        onload() {
            this.loading = true
            this.init()
            this.setTimeoutGetData()
        },
        setTimeoutGetData() {
            setInterval(() => {
                this.getUserInfo()
            }, 1000 * 60)
        },
        //  获取数据
        async init() {
            let _data = await dataScreenUserArr()
            this.cur_index = this.id ? _data.data.findIndex(f=>{ return f.jumin_id === this.id}) : 0
            console.log(this.cur_index)
            this.members = _data.data
            await this.getUserInfo()
        },
        //  获取数据
        async getUserInfo() {
            let _data = await dataScreenOneUser(this.members[this.cur_index].jumin_id)
            this.member_info = _data.data
            this.loading = false
        },
        changeMember(type) {
            if (this.cur_index === 0 && type === -1) {
                this.cur_index = this.members.length - 1
            } else if (this.cur_index === this.members.length - 1 && type === 1) {
                this.cur_index = 0
            } else {
                this.cur_index = this.cur_index + type
            }
            this.loading = true
            this.getUserInfo()
        },
        getCurrentTime() {
            setInterval(() => {
                this.cur_time = new Date().getTime()
            }, 1000)
        },
        getStyle(num, size = 16) {
            return `width:${num.toString().length * size}px`
        }
    },
    filters: {
        date_time(val) {
            return zhDate(val, 8)
        },
        service_type(val) {
            switch (Number(val)) {
                case 1 :
                    return '主动求救'
                case 2 :
                    return '心率异常'
                case 3 :
                    return '体温异常'
                case 4 :
                    return '血糖异常'
                case 5 :
                    return '血氧异常'
                case 6 :
                    return '血压异常'
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.container {
    height: 100vh;
    min-width: 1920px;
    min-height: 1080px;
    overflow: hidden;

    .loading {
        color: #ffffff;
        position: fixed;
        background: #33333333;
        z-index: 10;
    }



    .header-container {
        background: url(../../../assets/img/data/bg_monitoring.png) no-repeat top;
        background-size: 100% 100%;
        height: 102px;
        position: relative;
        padding: 0 36px;

        .page-title {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 36px;
            font-weight: 600;
            color: #ffffff;
        }

        .btn-container {
            transform: skew(25deg);
            width: 152px;
            height: 48px;
            min-width: 137px;
            line-height: 48px;
            box-shadow: inset 0px 0px 8px 3px #0096ff;
            background-color: #173979;
            text-align: center;
            font-size: 18px;
            color: #19caff;
            font-weight: 500;
            cursor: pointer;

            &.right {
                transform: skew(-25deg);

                .btn {
                    transform: skew(25deg);
                }
            }

            .btn {
                transform: skew(-25deg);
            }

            &.max {
                width: 282px;
            }

            &.mid {
                width: 182px;
            }
        }


    }

    .content-container {
        box-shadow: inset -10px 20px 18px -20px #0096ff;
        //background-color: #002262;
        padding: 26px;
        position: relative;
        .bg-anim {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            z-index: 0;
            object-fit: cover;
        }

        .info-container {
            box-shadow: inset 0px 0px 8px 3px #0096ff;
            background-image: linear-gradient(0deg,
                #0c5da399 0%,
                #00226299 100%);
            background-blend-mode: normal,
            normal;
            z-index: 1;

            .classify-title {
                background: url(../../../assets/img/data/bg_monitoring_title.png) no-repeat top;
                background-size: 100% 100%;
                width: 242px;
                height: 41px;
                line-height: 41px;
                text-align: center;
                font-size: 18px;
                font-weight: 600;
                color: #19caff;
            }

            &.max {
                width: 648px;
            }

            &.min {
                width: 540px;
                height: 615px;
            }


            &.member-container {
                padding: 0 30px;

                .member-operate-container {
                    background: linear-gradient(70deg, #073b8f22 0%, #0c68b255 30%, #0e73bb55 50%,
                        #0c68b255 80%, #073b8f22 100%);
                    margin-top: 20px;
                    height: 88px;

                    .operate {
                        box-shadow: inset 0px 0px 3px 3px #247bac;
                        width: 24px;
                        height: 65px;
                        line-height: 65px;
                        text-align: center;
                        font-size: 12px;
                        color: #19caff;
                        cursor: pointer;
                    }

                    .avatar {
                        width: 62px;
                        height: 62px;
                    }

                    .name {
                        font-size: 24px;
                        font-weight: 600;
                        color: #ffffff;
                    }

                    .year {
                        font-size: 18px;
                        color: #ffffff;

                        span {
                            color: #18c6fb;
                        }
                    }

                    .sex {
                        font-size: 18px;
                        color: #ffffff;

                        i {
                            color: #18c6fb;
                        }
                    }
                }

                .label-title {
                    font-size: 18px;
                    font-weight: 600;
                    color: #ffffff;
                    padding-left: 12px;
                    position: relative;

                    &::after {
                        position: absolute;
                        content: '';
                        width: 3px;
                        height: 17px;
                        background-color: #fff000;
                        left: 0;
                        top: 50%;
                        transform: translateY(-50%);
                    }

                }

                .info {
                    height: 28px;
                    background-color: #0d7bb833;
                    border-radius: 14px;
                    padding: 0 15px;
                    font-size: 16px;
                    line-height: 28px;
                    color: #ffffff;
                    flex-shrink: 0;
                    flex-grow: 1;

                    span {
                        color: #19caff;
                    }
                }

                .tag-container {
                    width: 100%;
                    overflow-x: auto;

                    &::-webkit-scrollbar {
                        background: transparent;
                        width: 2px;
                        height: 5px;
                    }

                    &::-webkit-scrollbar-thumb {
                        background: #18c6fb;
                        width: 2px;
                    }
                    .tag {
                        min-width: 90px;
                        height: 34px;
                        background-color: #0d7bb833;
                        border-radius: 17px;
                        padding: 0 12px;
                        font-size: 16px;
                        line-height: 34px;
                        text-align: center;
                        color: #ff5b5d;
                    }
                    .tag + .tag {
                        margin-left: 12px;
                    }

                }
                .service-item {
                    width: 113px;
                    height: 71px;
                    background-color: #0d7bb822;
                    border-radius: 10px;
                    padding: 12px 15px;
                    position: relative;
                    margin-top: 10px;
                    .number {
                        font-size: 20px;
                        font-weight: 600;
                        font-style: italic;
                        color: #19caff;
                    }
                    .label {
                        font-size: 16px;
                        color: #ffffff;
                        margin-top: 10px;
                    }
                    .image {
                        width: 39px;
                        position: absolute;
                        bottom: 11px;
                        right: 8px;
                        z-index: 0;
                    }
                }


            }

            &.yj-container {
                padding: 0 30px;

                .yj-item {
                    height: 34px;
                    background-color: #0d7bb866;
                    border-radius: 17px;
                    padding: 0 22px;
                    margin-top: 10px;

                    .label {
                        width: 24px;
                        height: 24px;
                        background-color: #df3030;
                        border-radius: 5px;
                        font-size: 16px;
                        line-height: 24px;
                        text-align: center;
                        color: #ffffff;
                        box-shadow: inset 0px 0px 3px 3px #ff5b5d;
                    }

                    .name {
                        font-size: 16px;
                        color: #ffffff;
                        margin-left: 10px;
                    }

                    .time {
                        font-size: 14px;
                        color: #ffffff;
                        opacity: 0.6;
                    }
                }
            }

            &.total-container {
                padding: 0 34px;

                .yj-total-container {
                    background-color: #010c7055;
                    border-radius: 10px;
                    border: solid 1px #19caff55;
                    padding: 12px 30px 32px;
                    margin-top: 12px;

                    .yj-item {
                        width: 249px;
                        height: 109px;
                        background-color: #0e6cb433;
                        border-radius: 10px;
                        padding: 23px 20px;
                        color: #15ade6;
                        margin-top: 10px;

                        &.min {
                            width: 160px;
                        }

                        &.error {
                            color: #ff4e4e;

                            .label {
                                color: #ff4e4e;
                            }
                        }

                        .icon {
                            font-size: 25px;
                        }

                        .label {
                            font-size: 20px;
                            color: #ffffff;
                        }

                        .state {
                            font-size: 16px;
                            margin-top: 12px;
                        }
                    }
                }

                .total-item {
                    width: 285px;
                    height: 124px;
                    background-color: #010c7055;
                    border-radius: 10px;
                    border: solid 1px #19caff55;
                    padding: 0 16px;
                    margin-top: 12px;

                    .label-container {
                        width: 59px;
                        height: 103px;
                        background-color: #0e6cb422;
                        border-radius: 10px;

                        .image {
                            width: 27px;
                        }

                        .label {
                            font-size: 18px;
                            color: #ffffff;
                            margin-top: 6px;
                        }
                    }

                    .echarts {
                        flex: 1;
                        height: 86px;
                    }

                    .number-container {
                        flex: 1;
                        background: linear-gradient(90deg, #ffffff01 0%, #ffffff01 10%, #062b66 50%, #ffffff01 90%, #ffffff01 100%);
                        background-blend-mode: normal, normal;
                        position: relative;
                        height: 64px;
                        margin: 0 20px;

                        &::after {
                            width: 100%;
                            height: 1px;
                            background: linear-gradient(70deg, #19caff33 0%, #1b85bf 30%, #19caff 50%, #1b85bf 80%, #19caff33 100%);
                            position: absolute;
                            content: '';
                            top: 0;
                            left: 0;
                            right: 0;
                        }

                        &::before {
                            width: 100%;
                            height: 1.5px;
                            background: linear-gradient(70deg, #19caff33 0%, #1b85bf 30%, #19caff 50%, #1b85bf 80%, #19caff33 100%);
                            position: absolute;
                            content: '';
                            bottom: 0;
                            left: 0;
                            right: 0;
                        }

                        .number {
                            font-size: 26px;
                            font-style: italic;
                            color: #62beff;
                        }

                        .label {
                            font-size: 18px;
                            color: #ffffff;
                            opacity: 0.5;
                            margin-left: 6px;
                        }

                        .address {
                            font-size: 16px;
                            color: #ffffff;
                        }
                    }
                }
            }
        }

        .anim-container {
            width: 730px;
            //background-image: url("../../../assets/img/data/bg_health_infoanim_anim.png");
            background-repeat: no-repeat;
            background-position: bottom center;
            position: relative;
            margin: 0 20px;

            .image {
                width: 574px;
                position: absolute;
                bottom: 157px;
                left: 50%;
                transform: translateX(-50%);
                user-select: none;
            }
        }


    }
}
</style>
